import { ReportRecord } from './reportRecord';
import { Options } from 'highcharts';
import { Observable } from 'rxjs/internal/Observable';
import { ContentModel, ReportFilterRequestSelection } from './models-index';
import { RolePermissions } from './security';
import { HttpErrorResponse } from '@angular/common/http';
export interface DatePeriodInfoModel {
  orgDateCode: number;
  startDate: Date;
  endDate: Date;
  year: number;
  month: number;
  quarter: number;
  isCurrentPeriod: boolean;
  periodName: string;
  daysInPeriod?: number;
}

export interface DashboardModel {
  title: string;
  iconClass: string;
  trendArrow: string;
  showTrendArrow: boolean;
  helpTextKey: string;
  helpTextTitle: string;
}

export interface BillboardModel {
  title: string;
  subtitle: string;
  subtitleOne: string;
  subtitleOneLabel: string;
  subtitleTwo: string;
  subtitleTwoLabel: string;
  iconClass: string;
  trendArrow: string;
  showTrendArrow: boolean;
  reverseMetric: boolean;
  metricCurrent: number;
  metricMOM: number;
  metricYOY: number;
  metricPreviousMonth: number;
  metricPreviousMTD: number;
  metricPreviousYear: number;
  footerRowCount: number;
  footerTwoLeftLabel: string;
  footerTwoRightLabel: string;
  helpTextKey: string;
  helpTextTitle: string;
  footerTwoMetricFormatter: () => {};
  metricFormatter: () => {};
  openHelpTextFunction: () => {};
}

export interface BillboardGraphConfig {
  title: string,
  iconClass: string,
  metricValue: string,
  metricTrendValue?: number,
  metricTrendInverted?: boolean,
  metricTrendArrowClass?: string,
  subtitle1Value?: string,
  subtitle2Value?: string,
  subtitle3Value?: string,
  footerOneLeftValue?: string,
  footerOneLeftLabel?: string,
  footerOneLeftColor?: string,
  footerOneRightValue?: string,
  footerOneRightLabel?: string,
  footerOneRightColor?: string,
  footerTwoLeftValue?: string,
  footerTwoLeftLabel?: string,
  footerTwoLeftColor?: string,
  footerTwoRightValue?: string,
  footerTwoRightLabel?: string,
  footerTwoRightColor?: string,
  helpTextKey: string,
  helpTextTitle: string,
  chartConfig?: Observable<Highcharts.Options>
}


export interface CalendarChart {
  propertyKey: string;
  dataTable: CalendarData[];
  formatKey: any;
  options: any;
}

export interface CalendarData {
  date: Date;
  value: number;
}


export interface ChatOverviewBillboardResponseModel extends ReportResponseModel {
  results: ChatOverviewBillboardReportRecord[];
}

export interface ChatOverviewBillboardReportRecord extends ReportRecord {
  isCurrentMonth: boolean;
  starts: number;
  startsPreviousMonth: number;
  startsMOM: number;
  startsPreviousMTD: number;
  startsYOY: number;
  engagementRate: number;
  engagementRatePreviousMonth: number;
  engagementRateMOM: number;
  engagementRatePreviousMTD: number;
  engagementRateYOY: number;
  impressions: number;
  impressionsPreviousMonth: number;
  impressionsMOM: number;
  impressionsPreviousMTD: number;
  impressionsYOY: number;
  startRate: number;
  startRatePreviousMonth: number;
  startRateMOM: number;
  startRatePreviousMTD: number;
  startRateYOY: number;
}

export interface ChatOverviewProviderTableResponseModel extends ReportResponseModel {
  results: ChatOverviewProviderTableReportRecord[];
}

export interface ChatOverviewProviderTableReportRecord extends ReportRecord {
  providerId: number;
  providerName: string;
  impressions: number;
  impressionsPreviousMonth: number;
  impressionsMOM: number;
  impressionsPreviousYear: number;
  impressionsYOY: number;
  starts: number;
  startsPreviousMonth: number;
  startsMOM: number;
  startsPreviousYear: number;
  startsYOY: number;
  startRate: number;
  startRatePreviousMonth: number;
  startRateMOM: number;
  startRatePreviousYear: number;
  startRateYOY: number;
  engagementRate: number;
  engagementRatePreviousMonth: number;
  engagementRateMOM: number;
  engagementRatePreviousYear: number;
  engagementRateYOY: number;
  abandonRate: number;
  abandonRatePreviousMonth: number;
  abandonRateMOM: number;
  abandonRatePreviousYear: number;
  abandonRateYOY: number;
  messagesPerChat: number;
  messagesPerChatPreviousMonth: number;
  messagesPerChatMOM: number;
  messagesPerChatPreviousYear: number;
  messagesPerChatYOY: number;
}

export interface IChatOverviewBillboardMetric {
  title: string;
  subtitle: string;
  subtitleOne: string;
  subtitleOneLabel: string;
  subtitleTwo: string;
  subtitleTwoLabel: string;
  iconClass: string;
  trendArrow: string;
  reverseMetric: boolean;
  metricCurrent: number;
  metricMOM: number;
  metricYOY: number;
  metricPreviousMonth: number;
  metricPreviousMTD: number;
  metricPreviousYear: number;
  footerRowCount: number;
  footerTwoLeftLabel: string;
  footerTwoRightLabel: string;
  helpTextKey: string;
  helpTextTitle: string;
  footerTwoMetricFormatter: () => {};
  metricFormatter: () => {};
  openHelpTextFunction: () => {};
}

export interface IProviderScorecard {
  providerCode: string;
  providerName: string;
  metrics: IProviderScorecardMetric[];
}

export interface IProviderScorecardMetric {
  metricId: number;
  metricName: string;
  metricPosition: number;
  filterPosition: number;
  seriesData: number[];
  metricValue: number;
  trendArrowIconClass: string;
  trendColor: string;
  trendChartLineColor: string;
  trendChartFillColor: string;
  metricFormatter: () => {};
}


// export interface ITradeInProviderScorecard {
//   providerId: number;
//   providerName: string;
//   metrics: ITradeInProviderScorecardMetric[];
// }

// export interface ITradeInProviderScorecardMetric {
//   metricId: number;
//   metricName: string;
//   metricPosition: number;
//   filterPosition: number;
//   seriesData: number[];
//   metricValue: number;
//   trendArrowIconClass: string;
//   trendColor: string;
//   trendChartLineColor: string;
//   trendChartFillColor: string;
//   metricFormatter: () => {};
// }

export interface IInventoryOverviewBillboardMetric {
  title: string;
  subtitle: string;
  iconClass: string;
  metricCurrent: number;
  metricPropertyName: string;
  metricPropertyId: number;
  metricMOM: number;
  metricPreviousMonth: number;
  chartDataSource: any[];
  footerLabel: string;
  helpTextKey: string;
  helpTextTitle: string;
  graphMetricFormatKey: string;
  trendArrowIconClass: string;
  footerMetricFormatter: () => {};
  metricFormatter: () => {};
  openHelpTextFunction: () => {};
}


export interface ILeadsOverviewBillboardMetric {
  title: string;
  subtitle: string;
  subtitleOne: string;
  subtitleOneLabel: string;
  subtitleTwo: string;
  subtitleTwoLabel: string;
  iconClass: string;
  trendArrow: string;
  showTrendArrow: boolean;
  reverseMetric: boolean;
  metricCurrent: number;
  metricMOM: number;
  metricYOY: number;
  metricPreviousMonth: number;
  metricPreviousMTD: number;
  metricPreviousYear: number;
  footerRowCount: number;
  footerTwoLeftLabel: string;
  footerTwoRightLabel: string;
  helpTextKey: string;
  helpTextTitle: string;
  footerTwoMetricFormatter: () => {};
  metricFormatter: () => {};
  openHelpTextFunction: () => {};
}

export interface IDigAdOverviewBillboardMetric {
  title: string;
  subtitle: string;
  subtitleOne: string;
  subtitleOneLabel: string;
  subtitleTwo: string;
  subtitleTwoLabel: string;
  iconClass: string;
  trendArrow: string;
  showTrendArrow: boolean;
  reverseMetric: boolean;
  metricCurrent: number;
  metricMOM: number;
  metricYOY: number;
  metricPreviousMonth: number;
  metricPreviousMTD: number;
  metricPreviousYear: number;
  footerRowCount: number;
  footerTwoLeftLabel: string;
  footerTwoRightLabel: string;
  helpTextKey: string;
  helpTextTitle: string;
  footerTwoMetricFormatter: () => {};
  metricFormatter: () => {};
  openHelpTextFunction: () => {};
}

export interface ISalesOverviewBillboardMetric {
  title: string;
  subtitle: string;
  subtitleOne: string;
  subtitleOneLabel: string;
  subtitleTwo: string;
  subtitleTwoLabel: string;
  iconClass: string;
  trendArrow: string;
  showTrendArrow: boolean;
  reverseMetric: boolean;
  metricCurrent: number;
  metricMOM: number;
  metricYOY: number;
  metricPreviousMonth: number;
  metricPreviousMTD: number;
  metricPreviousYear: number;
  footerRowCount: number;
  footerTwoLeftLabel: string;
  footerTwoRightLabel: string;
  helpTextKey: string;
  helpTextTitle: string;
  footerTwoMetricFormatter: () => {};
  metricFormatter: () => {};
  openHelpTextFunction: () => {};
}

export interface ISalesForecastingBillboardMetric {
  title: string;
  subtitle: string;
  subtitleOne: string;
  subtitleTwo: string;
  iconClass: string;
  trendArrow: string;
  metricTrendArrowClass: string;
  showTrendArrow: boolean;
  reverseMetric: boolean;
  metricCurrent: number;
  metricMOM: number;
  metricYOY: number;
  metricPreviousMonth: number;
  metricPreviousMTD: number;
  metricPreviousYear: number;
  footerRowCount: number;
  footerTwoLeftLabel: string;
  footerTwoRightLabel: string;
  helpTextKey: string;
  helpTextTitle: string;
  footerTwoMetricFormatter: () => {};
  metricFormatter: () => {};
  openHelpTextFunction: () => {};
  metricValue: number;
}

export interface IWebsiteOverviewBillboardMetric {
  title: string;
  subtitle: string;
  subtitleOne: string;
  subtitleOneLabel: string;
  subtitleTwo: string;
  subtitleTwoLabel: string;
  iconClass: string;
  trendArrow: string;
  showTrendArrow: boolean;
  reverseMetric: boolean;
  metricCurrent: number;
  metricMOM: number;
  metricYOY: number;
  metricPreviousMonth: number;
  metricPreviousMTD: number;
  metricPreviousYear: number;
  footerRowCount: number;
  footerTwoLeftLabel: string;
  footerTwoRightLabel: string;
  secondaryMetricCard: boolean;
  secondaryMetricLabel: string;
  secondaryMetric: string;
  helpTextKey: string;
  helpTextTitle: string;
  metricFormatter: () => {};
  secondaryMetricFormatter: () => {};
  footerTwoMetricFormatter: () => {};
  openHelpTextFunction: () => {};
}

export interface DigAdOverviewProviderKpiCard {
  name: string;
  actualCostPerClick: string;
  actualCostPerClickTrendArrow: string;
  actualCostPerImpression: string;
  actualCostPerImpressionTrendArrow: string;
  bounceRate: string;
  bounceRateTrendArrow: string;
  clicks: string;
  clicksTrendArrow: string;
  clickThroughRate: string;
  clickThroughRateTrendArrow: string;
  conversionRate: string;
  conversionRateTrendArrow: string;
  engagementRate: string;
  engagementRateTrendArrow: string;
  impressions: string;
  impressionsTrendArrow: string;
  formSubmissions: string;
  formSubmissionsTrendArrow: string;
  partOrders: string;
  partOrdersTrendArrow: string;
  phoneLeads: string;
  phoneLeadsTrendArrow: string;
  serviceSchedulers: string;
  serviceSchedulersTrendArrow: string;
  vdps: string;
  vdpsTrendArrow: string;
  visits: string;
  visitsTrendArrow: string;
  taggingVisits: string;
  taggingVisitsTrendArrow: string;
  salesWidth: number;
  salesTooltip: string;
  serviceWidth: number;
  serviceTooltip: string;
  otherWidth: number;
  otherTooltip: string;

  bouncesWidth: number;
  bouncesTooltip: string;
}

export interface WebsiteOverviewReferrerKpiCard {
  name: string;
  visits: string;
  visitsTrendArrow: string;
  vdps: string;
  vdpsTrendArrow: string;
  engagementRate: string;
  engagementRateTrendArrow: string;
  bounceRate: string;
  bounceRateTrendArrow: string;
  salesWidth: number;
  salesTooltip: string;
  salesSessionsConversionRate: string;
  salesSessionsConversionRateTrendArrow: string;
  serviceWidth: number;
  serviceTooltip: string;
  otherWidth: number;
  otherTooltip: string;
  bouncesWidth: number;
  bouncesTooltip: string;
}

export interface IWebsiteProviderScorecard {
  providerId: number;
  providerName: string;
  metrics: IWebsiteProviderScorecardMetric[];
}

export interface IWebsiteProviderScorecardMetric {
  metricId: number;
  metricName: string;
  metricPosition: number;
  filterPosition: number;
  seriesData: number[];
  metricValue: number;
  trendArrowIconClass: string;
  trendColor: string;
  trendChartLineColor: string;
  trendChartFillColor: string;
  metricFormatter: () => {};
}

export interface IWebsiteScorecardCategory {
  category: string;
  billboards: IWebsiteScorecardMetric[];
}

export interface IWebsiteScorecardMetric {
  title: string;
  subtitle: string;
  iconClass: string;
  trendArrow: string;
  reverseMetric: boolean;
  metricCurrent: number;
  metricPreviousMonth: number;
  secondaryMetric: number;
  secondaryMetricLabel: string;
  subtitleMetric: number;
  metricMOM: number;
  metricPreviousYear: number;
  metricYOY: number;
  footerLeftLabel: string;
  footerRightLabel: string;
  helpTextKey: string;
  helpTextTitle: string;
  scorecardCategory: string;
  secondaryMetricFormatter: () => {};
  subtitleMetricFormatter: () => {};
  footerMetricFormatter: () => {};
  metricFormatter: () => {};
  openHelpTextFunction: () => {};
}

export interface IDefaultTableColumn {
  show: boolean;
  print?: boolean;
  header: string;
  columnDef: string;
  columnClasses?: string[];
  isMom: boolean;
  isYoy: boolean;
  isLookback?: boolean;
  clickable?: boolean;
  sortable?: boolean;
  valueInverted?: boolean;
  formatter: (val?: any) => {};
  printFormatter?: (val?: any) => {};
  canDrillthrough?: (val: any) => boolean;
}

export type ResourceStringMap = { [key: string]: { [key: string]: string } };

export interface IAppConfig {
  resourceStrings: ResourceStringMap;
}

export interface ISingleAxisTrendChartSettings {
  xAxisPropertyName: string;
  chartTitle: string;
  chartColors: string[];
  yAxisTitle: string;
  seriesOneDisplayName: string;
  seriesOneFormatKey: string;
  seriesOnePropertyName: string;
  seriesTwoFormatKey: string;
  seriesTwoDisplayName: string;
  seriesTwoPropertyName: string;
  seriesThreeFormatKey?: string;
  seriesThreeDisplayName?: string;
  seriesThreePropertyName?: string;
  showRateMetric?: boolean;
  rateMetricDisplayName?: string;
}

export interface ITrendGraphData {
  metricId: number;
  data: number[];
}

export interface ITrendGraph {
  dates: any;
  metrics: ITrendGraphData[];
  xAxisValues?: any[];
  metricOneColorHexCode: string;
  metricTwoColorHexCode: string;
}

export interface IMultiLevelMetric {
  id: any;
  metrics: ITrendGraphData[];
}

export interface IMultiLevelTrendGraph {
  dates: any;
  xAxisValues?: any[];
  metrics: IMultiLevelMetric[];
  ids: string[];
  metricOneColorHexCode: string;
  metricTwoColorHexCode: string;
}

export interface IChartSeries {
  name: string;
  type: string;
  yAxis: number;
  data: number[];
  color: string;
  marker: any;
  lineWidth: number;
}

export interface IBarChartCard {
  dimensionName: string;
  metricOneName?: string;
  metricTwoName?: string;
  metricThreeName?: string;
  barValues: {
    dimensionValueName: string;
    metricOneDisplay?: string;
    metricOneTrendValue?: number;
    metricTwoDisplay?: string;
    metricTwoTrendValue?: number;
    metricThreeDisplay?: string;
    metricThreeTrendValue?: number;
    barWidth: string;
    tooltipText: string;
    barStyleOne: any;
    barStyleTwo: any;
  }[];
}

export interface IRooftop {
  regionName: string;
  rooftopId: number;
  rooftopName: string;
  defaultBrandId: number;
  supportedBrands: IBrand[];
  latitude: number;
  longitude: number;
  mapLatitude: number;
  mapLongitude: number;
}

export interface IOrgLookupResponseModel {
  results: IOrgLookup[];
}

export interface IOrgLookup {
  dealerCode: string;
  dealerName: string;
  dealerFilterDisplayName: string;
  dealerLatitude: number;
  dealerLongitude: number;
  dealerIsActive: boolean;
  orgCode1: string;
  orgCode1Name: string;
  orgCode1FilterDisplayName: string;
  orgCode1Latitude: number;
  orgCode1Longitude: number;
  orgCode2: string;
  orgCode2Name: string;
  orgCode2FilterDisplayName: string;
  orgCode2Latitude: number;
  orgCode2Longitude: number;
  orgCode3: string;
  orgCode3Name: string;
  orgCode3FilterDisplayName: string;
  orgCode3Latitude: number;
  orgCode3Longitude: number;
  orgCode4: string;
  orgCode4Name: string;
  orgCode4FilterDisplayName: string;
  orgCode4Latitude: number;
  orgCode4Longitude: number;
  orgCode5: string;
  orgCode5Name: string;
  orgCode5FilterDisplayName: string;
  orgCode5Latitude: number;
  orgCode5Longitude: number;
  orgLookupTypeId: number;
  orgLookupTypeName: string;
}


export interface IProfitCenter {
  profitCenterId: number;
  name: string;
}

export interface IDigAdProgram {
  digAdProgramId: number;
  name: string;
}

export interface IVehicleLookupResponseModel {
  results: IVehicleLookup[];
}

export interface IVehicleLookup {
  vehicleClass: string;
  vehicleModel: string;
}

export interface IDealerLookupResponseModel {
  dealers: IDealerLookup[];
}

export interface IDealerLookup {
  dealerCode: string;
  dealerName: string;
  latitude: number;
  longitude: number;
  orgCode1: string;
  orgCode1Name: string;
  orgCode2: string;
  orgCode2Name: string;
  orgCode3: string;
  orgCode3Name: string;
  orgCode4: string;
  orgCode4Name: string;
  orgCode5: string;
  orgCode5Name: string;
  orgLookupTypeId: number;
}


export interface IProductLine {
  name: string;
  productLineId: number;
}

export interface ISalesUnit {
  name: string;
  salesUnitId: number;
}

export interface IProviderLookup {
  providerId: number;
  name: string;
  code: string;
  isChatProvider: boolean;
  isDigAdProvider: boolean;
  isDRProvider: boolean;
  isPartsAndServiceProvider: boolean;
  isReputationProvider: boolean;
  isServiceSchedulerProvider: boolean;
  isSocialMediaProvider: boolean;
  isTradeInProvider: boolean;
  isWebProvider: boolean;
}

export interface IChatProvider {
  certifiedChatProviderId: number;
  name: string;
}

export interface IDealerSize {
  id: number;
  name: string;
}

export interface IRole {
  roleId: number;
  name: string;
  defaultRoute?: string;
  permissions?: RolePermissions[];
}

export interface ISaleTypeResponseModel {
  results: ISaleType[];
}

export interface ISaleType {
  saleTypeId: number;
  name: string;
}

export interface ISourceTypeResponseModel {
  results: ISourceType[];
}

export interface ISourceType {
  name: string;
  sourceTypeId: number;
}

export interface ILeadType {
  leadTypeId: number;
  name: string;
}

export interface ITraitFilter {
  traitId: number;
  name: string;
}

export interface IVehicleModel {
  modelName: string;
  vehicleModelId: number;
}

export interface IDealType {
  name: string;
  id: number;
}

export interface ILeadGate {
  name: string;
  id: number;
}

export interface IVehicleType {
  name: string;
  id: number;
}

export interface IVehicleMake {
  vehicleMakeId: number;
  name: string;
}

export interface ILeadDesignation {
  leadDesignationId: number;
  name: string;
}

export interface IDeviceTypeResponseModel {
  results: IDeviceType[];
}

export interface IDeviceType {
  name: string;
  deviceTypeId: number;
}

export interface IBrand {
  name: string;
  brandId: number;
}

export interface ICampaignType {
  name: string;
  campaignTypeId: number;
}

export interface IAudienceSegment {
  name: string;
  audienceSegmentId: number;
}

export interface IJourneySegment {
  name: string;
  journeySegmentId: number;
}

export interface IRole {
  name: string;
  roleId: number;
}
export interface IPage {
  name: string;
  pageId: number;
  pageTypeId: number;
  pageTypeName: string;
}

export interface IChannel {
  name: string;
  channelId: number;
  channelTypeId: number;
  mediaTypeId: number;
}

export interface ISocialMediaPlatform {
  socialMediaPlatformId: number;
  name: string;
  code: string;
  tokens: string;
}

export interface IReputationPlatform {
  reputationPlatformId: number;
  name: string;
  code: string;
  tokens: string;
}

export interface IKeyValuePair {
  id: number;
  name: string;
}

export interface INameValuePair {
  value: string;
  name: string;
}

export interface IThirdPartyLeadProvider {
  name: string;
  costPerLead: number;
}

export interface IDealerHierarchyDealer {
  dealerCode: string;
  name: string;
  latitude: string;
  longitude: string;
  rooftopId: string;
}

export interface IDealerHierarchyRegion {
  regionName: string;
  orgLookupIds: number[];
  dealers: IDealerHierarchyDealer[];
}

export interface IDashboardChartMetricOptions {
  responseRate: string;
  closeRate: string;
}

export interface IDashboardMapMetricOptions {
  responseTime: string;
  closeRate: string;
}

export interface ListRequestModel {
  pageNumber?: number;
  pageSize?: number;
  orderBy: string;
  orderAscending: boolean;
  searchTerm?: string;
}

export interface ContentListResponseModel extends ListResponseModel<ContentModel> {
  sections: SectionModel[];
}

export interface SectionModel {
  id: number;
  name: string;
}

export interface ListResponseModel<T> {
  pageLength: number;
  pageNumber: number;
  totalRecords: number;
  results: T[];
}

export interface ReportRequestModel {
  orderBy: string;
  orderAscending: boolean;
  reportType: string;
  filters: IFilterModel;
  selections?: SelectionsModel[];
  filterSelections?: ReportFilterRequestSelection[];
  options?: { [key: string]: any };
  dataSets?: string[];
}

export interface OptionModel {
  name: string;
  label?: string;
  enabled: boolean;
  exlusive?: boolean;
}

export interface SelectionsModel {
  panelName: string;
  panelConfigurationName?: string;
  options?: OptionModel
}

export interface ColumnModel {
  rowKey?: string;
  name: string;
  dataValue?: string | number;
  isPrefix?: boolean;
  isSuffix?: boolean;
  firstStickyEnd?: boolean;
}

export interface ReportResponseModel {
  reportType: string;
  pageLength: number;
  pageNumber: number;
  totalRecords: number;
  columns?: ColumnModel[];
  rows?: any[];
  results?: any[]; // JMSTODO: added this for MB reporting - needed to push - fix and remove
}

export interface FileContentConfig {
  id: number;
  name: string;
  uri: string;
  fileName: string;
  fileType: any;
  thumbnailUrl: string;
}

export interface FilesInSectionsModel {
  sectionId: number;
  sectionName: string;
  order?: number;
  files: FileContentConfig[];
}

export interface IExpandableTable {
  expanded: boolean;
  toggleExpanded(): void;
}

export interface IFilterModel {
  accountName?: string;
  appointmentDispositionActivityId?: number;
  audienceSegments?: string;
  brands?: string;
  campaignTypes?: string;
  dealerSize?: string;
  channelId?: number;
  channels?: string;
  chatProviders?: string;
  closeRate?: string;
  culture?: string;
  currentSalesMonth?: Date;
  dayOfSalesMonth?: number;
  dealer?: string;
  dealerCode?: string;
  dealTypes?: string;
  deviceTypeId?: number;
  deviceTypes?: string;
  digAdProviderId?: number;
  digAdProviders?: string;
  digAdPrograms?: string;
  displayDateMode?: number;
  email?: string;
  endDate: Date;
  focus?: string;
  groupingColumn?: string;
  includeAllNewMakes?: boolean;
  includeMom?: boolean;
  includeYoy?: boolean;
  inventoryStatus?: string;
  inventoryTypes?: string;
  isBrandMode?: boolean;
  journeySegments?: string;
  lastName?: string;
  leadDesignations?: string;
  leadId?: number;
  leadGates?: string;
  leadTypeId?: number;
  leadTypes?: string;
  makes?: string;
  mediaTypeId?: number;
  mediaTypes?: string;
  models?: string;
  orgCode1?: string;
  orgCode2?: string;
  orgCode3?: string;
  orgCode4?: string;
  orgCode5?: string;
  orgDateCode?: number;
  orgLookupTypeId?: number;
  pages?: string;
  phone?: string;
  previousEndDate?: Date;
  previousStartDate?: Date;
  previousYearEndDate?: Date;
  previousYearStartDate?: Date;
  productLines?: string;
  providerId?: number;
  profitCenterId?: number;
  profitCenters?: string;
  providers?: string;
  providerList?: string;
  quarter?: number;
  quarterYear?: string;
  radius?: number;
  referrerTypeId?: number;
  referrerTypes?: string;
  reputationPlatforms?: string;
  reputationProviders?: string;
  roleEntity?: string;
  roleId?: number;
  roleLevel?: string;
  roles?: string;
  saleTypes?: string;
  salesUnits?: string;
  serviceSchedulerProviders?: string;
  showInactiveDealers?: boolean;
  socialMediaPlatforms?: string;
  socialMediaProviders?: string;
  sourceTypeId?: number;
  sourceTypes?: string;
  startDate: Date;
  strategies?: string;
  tactics?: string;
  traits?: string;
  tradeInProviders?: string;
  userType?: string;
  vehicleMake?: string;
  vehicleClass?: string;
  vehicleModel?: string;
  vehicleMakes?: string;
  vehicleClasses?: string;
  vehicleModels?: string;
  vehicleSeries?: string;
  vehicleStatusId?: number;
  vehicleTypes?: string;
  websiteProviderId?: number;
  websiteProviders?: string;
  year?: number;
}

export interface IStackedBarChartSeries {
  name: string;
  data: number[];
}

export interface IStackedBarChartSeriesWithId {
  name: string;
  data: IDataPointWithId[];
}

export interface IDataPointWithId {
  y: number;
  id: string;
}

export interface CertifiedChatGraphResponseModel extends ReportResponseModel {
  results: CertifiedChatGraphMetricReportRecord[];
}

export interface CertifiedChatGraphMetricReportRecord extends ReportRecord {

}

export interface CertifiedChatTableResponseModel extends ReportResponseModel {
  results: CertifiedChatTableMetricReportRecord[];
}

export interface CertifiedChatTableMetricReportRecord extends ReportRecord {

}

export interface DigitalAdvertisingOverviewBillboardResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingOverviewBillboardReportRecord[];
}

export interface DigitalAdvertisingOverviewBillboardReportRecord extends ReportRecord {
  impressions: number;
  impressionsPreviousMonth: number;
  impressionsPreviousYear: number;
  impressionsMOM: number;
  impressionsYOY: number;
  visits: number;
  visitsPreviousMonth: number;
  visitsPreviousYear: number;
  visitsMOM: number;
  visitsYOY: number;
  searchClicks: number;
  searchClicksPreviousMonth: number;
  searchClicksPreviousYear: number;
  searchClicksMOM: number;
  searchClicksYOY: number;
  displayClicks: number;
  displayClicksPreviousMonth: number;
  displayClicksPreviousYear: number;
  displayClicksMOM: number;
  displayClicksYOY: number;
  engagements: number;
  engagementsPreviousMonth: number;
  engagementsPreviousYear: number;
  engagementsMOM: number;
  engagementsYOY: number;
  engagementRate: number;
  engagementRatePreviousMonth: number;
  engagementRatePreviousYear: number;
  engagementRateMOM: number;
  engagementRateYOY: number;
  actions: number;
  actionsPreviousMonth: number;
  actionsPreviousYear: number;
  actionsMOM: number;
  actionsYOY: number;
  actionRate: number;
  actionRatePreviousMonth: number;
  actionRatePreviousYear: number;
  actionRateMOM: number;
  actionRateYOY: number;
}

export interface DigitalAdvertisingOverviewChannelSummaryResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingOverviewChannelSummaryReportRecord[];
}

export interface DigitalAdvertisingOverviewChannelSummaryReportRecord extends ReportRecord {
  channelName: string;
  totalVisits: number;
  engagedVisits: number;
}

export interface DigitalAdvertisingOverviewTrafficTrendResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingOverviewTrafficTrendReportRecord[];
}

export interface DigitalAdvertisingOverviewTrafficTrendReportRecord extends ReportRecord {
  date: Date;
  totalVisits: number;
  engagedVisits: number;
  uniqueVisits: number;
}

export interface DigitalAdvertisingOverviewTrafficTypeResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingOverviewTrafficTypeReportRecord[];
}

export interface DigitalAdvertisingOverviewTrafficTypeReportRecord extends ReportRecord {
  organicVisits: number;
  paidVisits: number;
}

export interface DigitalAdvertisingOverviewProviderSummaryResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingOverviewProviderSummaryReportRecord[];
}

export interface DigitalAdvertisingOverviewProviderSummaryReportRecord extends ReportRecord {
  name: string;
  visits: number;
  visitsMOM: number;
  vdps: number;
  vdpsMOM: number;
  engagementRate: number;
  engagementRateMOM: number;
  bounceRate: number;
  bounceRateMOM: number;
  sales: number;
  service: number;
  other: number;
  bounces: number;
}

export interface DigitalAdvertisingOverviewDealerPerformanceResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingOverviewDealerPerformanceReportRecord[];
}

export interface DigitalAdvertisingOverviewDealerPerformanceReportRecord extends ReportRecord {
  dealerName: string;
  dealerCode: string;
  district: string;
  region: string;
  pageViews: number;
  pageViewsPreviousMonth: number;
  pageViewsPreviousYear: number;
  pageViewsMOM: number;
  pageViewsYOY: number;
  newVdps: number;
  newVdpsPreviousMonth: number;
  newVdpsPreviousYear: number;
  newVdpsMOM: number;
  newVdpsYOY: number;
  usedVdps: number;
  usedVdpsPreviousMonth: number;
  usedVdpsPreviousYear: number;
  usedVdpsMOM: number;
  usedVdpsYOY: number;
  serviceViews: number;
  serviceViewsPreviousMonth: number;
  serviceViewsPreviousYear: number;
  serviceViewsMOM: number;
  serviceViewsYOY: number;
  engagementRate: number;
  engagementRatePreviousMonth: number;
  engagementRatePreviousYear: number;
  engagementRateMOM: number;
  engagementRateYOY: number;
  actionRate: number;
  actionRatePreviousMonth: number;
  actionRatePreviousYear: number;
  actionRateMOM: number;
  actionRateYOY: number;
  averageTimeOnSite: number;
  averageTimeOnSitePreviousMonth: number;
  averageTimeOnSitePreviousYear: number;
  averageTimeOnSiteMOM: number;
  averageTimeOnSiteYOY: number;
  impressions: number;
  impressionsPreviousMonth: number;
  impressionsMOM: number;
  impressionsPreviousYear: number;
  impressionsYOY: number;
  clicks: number;
  clicksPreviousMonth: number;
  clicksMOM: number;
  clicksPreviousYear: number;
  clicksYOY: number;
  clickThroughRate: number;
  clickThroughRatePreviousMonth: number;
  clickThroughRateMOM: number;
  clickThroughRatePreviousYear: number;
  clickThroughRateYOY: number;
  costPerClick: number;
  costPerClickPreviousMonth: number;
  costPerClickMOM: number;
  costPerClickPreviousYear: number;
  costPerClickYOY: number;
  costPerImpression: number;
  costPerImpressionPreviousMonth: number;
  costPerImpressionMOM: number;
  costPerImpressionPreviousYear: number;
  costPerImpressionYOY: number;
  totalVisits: number;
  totalVisitsPreviousMonth: number;
  totalVisitsMOM: number;
  totalVisitsPreviousYear: number;
  totalVisitsYOY: number;
  uniqueVisits: number;
  uniqueVisitsPreviousMonth: number;
  uniqueVisitsMOM: number;
  uniqueVisitsPreviousYear: number;
  uniqueVisitsYOY: number;
  formSubmissions: number;
  formSubmissionsPreviousMonth: number;
  formSubmissionsMOM: number;
  formSubmissionsPreviousYear: number;
  formSubmissionsYOY: number;
  phoneCalls: number;
  phoneCallsPreviousMonth: number;
  phoneCallsMOM: number;
  phoneCallsPreviousYear: number;
  phoneCallsYOY: number;
  conversionRate: number;
  conversionRatePreviousMonth: number;
  conversionRateMOM: number;
  conversionRatePreviousYear: number;
  conversionRateYOY: number;
  costPerAcquisition: number;
  costPerAcquisitionPreviousMonth: number;
  costPerAcquisitionMOM: number;
  costPerAcquisitionPreviousYear: number;
  costPerAcquisitionYOY: number;
  bounceRate: number;
  bounceRatePreviousMonth: number;
  bounceRateMOM: number;
  bounceRatePreviousYear: number;
  bounceRateYOY: number;
}


export interface IDigitalAdvertisingScorecardCategory {
  category: string;
  billboards: IDigitalAdvertisingScorecardMetric[];
}

export interface IDigitalAdvertisingScorecardMetric {
  title: string;
  subtitle: string;
  iconClass: string;
  trendArrow: string;
  reverseMetric: boolean;
  metricCurrent: number;
  metricPreviousMonth: number;
  secondaryMetric: number;
  secondaryMetricLabel: string;
  subtitleMetric: number;
  metricMOM: number;
  metricPreviousYear: number;
  metricYOY: number;
  footerLeftLabel: string;
  footerRightLabel: string;
  helpTextKey: string;
  helpTextTitle: string;
  scorecardCategory: string;
  secondaryMetricFormatter: () => {};
  subtitleMetricFormatter: () => {};
  footerMetricFormatter: () => {};
  metricFormatter: () => {};
  openHelpTextFunction: () => {};
}




export interface DigitalAdvertisingOverviewDealerSummaryResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingOverviewDealerPerformanceReportRecord[];
}

export interface DigitalAdvertisingOverviewDealerSummaryReportRecord extends ReportRecord { }

export interface DigitalAdvertisingSummaryGraphResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingSummaryGraphReportRecord[];
}

export interface DigitalAdvertisingScorecardMetricResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingScorecardMetricReportRecord[];
}

export interface DigitalAdvertisingScorecardMetricReportRecord extends ReportRecord {
  engagementRate?: number;
  engagementRatePreviousMonth?: number;
  engagementRateMOM?: number;
  engagementRatePreviousYear?: number;
  engagementRateYOY?: number;
  actionRate?: number;
  actionRatePreviousMonth?: number;
  actionRateMOM?: number;
  actionRatePreviousYear?: number;
  actionRateYOY?: number;
  impressions?: number;
  impressionsPreviousMonth?: number;
  impressionsMOM?: number;
  impressionsPreviousYear?: number;
  impressionsYOY?: number;
  clicks?: number;
  clicksPreviousMonth?: number;
  clicksMOM?: number;
  clicksPreviousYear?: number;
  clicksYOY?: number;
  clickToCalls?: number;
  clickToCallsPreviousMonth?: number;
  clickToCallsMOM?: number;
  clickToCallsPreviousYear?: number;
  clickToCallsYOY?: number;
  clickThroughRate?: number;
  clickThroughRatePreviousMonth?: number;
  clickThroughRateMOM?: number;
  clickThroughRatePreviousYear?: number;
  clickThroughRateYOY?: number;
  costPerClick?: number;
  costPerClickPreviousMonth?: number;
  costPerClickMOM?: number;
  costPerClickPreviousYear?: number;
  costPerClickYOY?: number;
  costPerImpression?: number;
  costPerImpressionPreviousMonth?: number;
  costPerImpressionMOM?: number;
  costPerImpressionPreviousYear?: number;
  costPerImpressionYOY?: number;
  totalVisits?: number;
  totalVisitsPreviousMonth?: number;
  totalVisitsMOM?: number;
  totalVisitsPreviousYear?: number;
  totalVisitsYOY?: number;
  uniqueVisits?: number;
  uniqueVisitsPreviousMonth?: number;
  uniqueVisitsMOM?: number;
  uniqueVisitsPreviousYear?: number;
  uniqueVisitsYOY?: number;
  formSubmissions?: number;
  formSubmissionsPreviousMonth?: number;
  formSubmissionsMOM?: number;
  formSubmissionsPreviousYear?: number;
  formSubmissionsYOY?: number;
  phoneCalls?: number;
  phoneCallsPreviousMonth?: number;
  phoneCallsMOM?: number;
  phoneCallsPreviousYear?: number;
  phoneCallsYOY?: number;
  conversionRate?: number;
  conversionRatePreviousMonth?: number;
  conversionRateMOM?: number;
  conversionRatePreviousYear?: number;
  conversionRateYOY?: number;
  costPerAcquisition?: number;
  costPerAcquisitionPreviousMonth?: number;
  costPerAcquisitionMOM?: number;
  costPerAcquisitionPreviousYear?: number;
  costPerAcquisitionYOY?: number;
  bounceRate?: number;
  bounceRatePreviousMonth?: number;
  bounceRateMOM?: number;
  bounceRatePreviousYear?: number;
  bounceRateYOY?: number;
  avgTimeOnSite?: number;
  avgTimeOnSitePreviousMonth?: number;
  avgTimeOnSiteMOM?: number;
  avgTimeOnSitePreviousYear?: number;
  avgTimeOnSiteYOY?: number;
  vdpViews?: number;
  vdpViewsPreviousMonth?: number;
  vdpViewsMOM?: number;
  vdpViewsPreviousYear?: number;
  vdpViewsYOY?: number;
  pageViews?: number;
  pageViewsPreviousMonth?: number;
  pageViewsMOM?: number;
  pageViewsPreviousYear?: number;
  pageViewsYOY?: number;
}

export interface DigitalAdvertisingSummaryGraphReportRecord extends ReportRecord {
  date: Date;
  channelName: string;
  impressions: number;
  clicks: number;
  totalVisits: number;
  uniqueVisitors: number;
  formSubmissions: number;
  phoneCalls: number;
  bounceRate: number;
  actionRate: number;
  engagementRate: number;
  conversionRate: number;
  costPerAcquisition: number;
  clickThroughRate: number;
  costPerClick: number;
  costPerImpression: number;
}

export interface DigitalAdvertisingSummaryTableResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingSummaryTableReportRecord[];
}

export interface DigitalAdvertisingSummaryTableReportRecord extends ReportRecord {
  entity: string;
  entityType: string;
  parentEntity: string;
  displayName: string;
  expandable: boolean;
  show: boolean;
  showChildren: boolean;
  hasChildren: boolean;
  engagementRate: number;
  engagementRatePreviousMonth: number;
  engagementRateMOM: number;
  engagementRatePreviousYear: number;
  engagementRateYOY: number;
  actionRate: number;
  actionRatePreviousMonth: number;
  actionRateMOM: number;
  actionRatePreviousYear: number;
  actionRateYOY: number;
  impressions: number;
  impressionsPreviousMonth: number;
  impressionsMOM: number;
  impressionsPreviousYear: number;
  impressionsYOY: number;
  clicks: number;
  clicksPreviousMonth: number;
  clicksMOM: number;
  clicksPreviousYear: number;
  clicksYOY: number;
  clickThroughRate: number;
  clickThroughRatePreviousMonth: number;
  clickThroughRateMOM: number;
  clickThroughRatePreviousYear: number;
  clickThroughRateYOY: number;
  costPerClick: number;
  costPerClickPreviousMonth: number;
  costPerClickMOM: number;
  costPerClickPreviousYear: number;
  costPerClickYOY: number;
  costPerImpression: number;
  costPerImpressionPreviousMonth: number;
  costPerImpressionMOM: number;
  costPerImpressionPreviousYear: number;
  costPerImpressionYOY: number;
  totalVisits: number;
  totalVisitsPreviousMonth: number;
  totalVisitsMOM: number;
  totalVisitsPreviousYear: number;
  totalVisitsYOY: number;
  uniqueVisits: number;
  uniqueVisitsPreviousMonth: number;
  uniqueVisitsMOM: number;
  uniqueVisitsPreviousYear: number;
  uniqueVisitsYOY: number;
  formSubmissions: number;
  formSubmissionsPreviousMonth: number;
  formSubmissionsMOM: number;
  formSubmissionsPreviousYear: number;
  formSubmissionsYOY: number;
  phoneCalls: number;
  phoneCallsPreviousMonth: number;
  phoneCallsMOM: number;
  phoneCallsPreviousYear: number;
  phoneCallsYOY: number;
  conversionRate: number;
  conversionRatePreviousMonth: number;
  conversionRateMOM: number;
  conversionRatePreviousYear: number;
  conversionRateYOY: number;
  costPerAcquisition: number;
  costPerAcquisitionPreviousMonth: number;
  costPerAcquisitionMOM: number;
  costPerAcquisitionPreviousYear: number;
  costPerAcquisitionYOY: number;
  bounceRate: number;
  bounceRatePreviousMonth: number;
  bounceRateMOM: number;
  bounceRatePreviousYear: number;
  bounceRateYOY: number;
}

export interface DigitalAdvertisingSummaryTrendTableResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingSummaryTrendTableReportRecord[];
}

export interface DigitalAdvertisingSummaryTrendTableReportRecord extends ReportRecord {

}

export interface DigitalAdvertisingChannelSummaryGraphResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingChannelSummaryGraphReportRecord[];
}

export interface DigitalAdvertisingChannelSummaryGraphReportRecord extends ReportRecord {
  date: Date;
  channelName: string;
  impressions: number;
  clicks: number;
  totalVisits: number;
  uniqueVisitors: number;
  formSubmissions: number;
  phoneCalls: number;
  bounceRate: number;
  actionRate: number;
  engagementRate: number;
  conversionRate: number;
  costPerAcquisition: number;
  clickThroughRate: number;
  costPerClick: number;
  costPerImpression: number;
}

export interface DigitalAdvertisingChannelSummaryTableResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingChannelSummaryTableReportRecord[];
}

export interface DigitalAdvertisingChannelSummaryTableReportRecord extends ReportRecord {
  entity: string;
  entityType: string;
  parentEntity: string;
  displayName: string;
  expandable: boolean;
  show: boolean;
  showChildren: boolean;
  hasChildren: boolean;
  engagementRate: number;
  engagementRatePreviousMonth: number;
  engagementRateMOM: number;
  engagementRatePreviousYear: number;
  engagementRateYOY: number;
  actionRate: number;
  actionRatePreviousMonth: number;
  actionRateMOM: number;
  actionRatePreviousYear: number;
  actionRateYOY: number;
  impressions: number;
  impressionsPreviousMonth: number;
  impressionsMOM: number;
  impressionsPreviousYear: number;
  impressionsYOY: number;
  clicks: number;
  clicksPreviousMonth: number;
  clicksMOM: number;
  clicksPreviousYear: number;
  clicksYOY: number;
  clickThroughRate: number;
  clickThroughRatePreviousMonth: number;
  clickThroughRateMOM: number;
  clickThroughRatePreviousYear: number;
  clickThroughRateYOY: number;
  costPerClick: number;
  costPerClickPreviousMonth: number;
  costPerClickMOM: number;
  costPerClickPreviousYear: number;
  costPerClickYOY: number;
  costPerImpression: number;
  costPerImpressionPreviousMonth: number;
  costPerImpressionMOM: number;
  costPerImpressionPreviousYear: number;
  costPerImpressionYOY: number;
  totalVisits: number;
  totalVisitsPreviousMonth: number;
  totalVisitsMOM: number;
  totalVisitsPreviousYear: number;
  totalVisitsYOY: number;
  uniqueVisits: number;
  uniqueVisitsPreviousMonth: number;
  uniqueVisitsMOM: number;
  uniqueVisitsPreviousYear: number;
  uniqueVisitsYOY: number;
  formSubmissions: number;
  formSubmissionsPreviousMonth: number;
  formSubmissionsMOM: number;
  formSubmissionsPreviousYear: number;
  formSubmissionsYOY: number;
  phoneCalls: number;
  phoneCallsPreviousMonth: number;
  phoneCallsMOM: number;
  phoneCallsPreviousYear: number;
  phoneCallsYOY: number;
  conversionRate: number;
  conversionRatePreviousMonth: number;
  conversionRateMOM: number;
  conversionRatePreviousYear: number;
  conversionRateYOY: number;
  costPerAcquisition: number;
  costPerAcquisitionPreviousMonth: number;
  costPerAcquisitionMOM: number;
  costPerAcquisitionPreviousYear: number;
  costPerAcquisitionYOY: number;
  bounceRate: number;
  bounceRatePreviousMonth: number;
  bounceRateMOM: number;
  bounceRatePreviousYear: number;
  bounceRateYOY: number;
}

export interface DigitalAdvertisingProviderSummaryGraphResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingProviderSummaryGraphReportRecord[];
}

export interface DigitalAdvertisingProviderSummaryGraphReportRecord extends ReportRecord {
  date: Date;
  providerName: string;
  impressions: number;
  clicks: number;
  totalVisits: number;
  uniqueVisitors: number;
  formSubmissions: number;
  phoneCalls: number;
  bounceRate: number;
  actionRate: number;
  engagementRate: number;
  conversionRate: number;
  costPerAcquisition: number;
  clickThroughRate: number;
  costPerClick: number;
  costPerImpression: number;
}

export interface DigitalAdvertisingProviderSummaryTableResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingProviderSummaryTableReportRecord[];
}

export interface DigitalAdvertisingProviderSummaryTableReportRecord extends ReportRecord {
  entity: string;
  entityType: string;
  parentEntity: string;
  displayName: string;
  expandable: boolean;
  show: boolean;
  showChildren: boolean;
  hasChildren: boolean;
  engagementRate: number;
  engagementRatePreviousMonth: number;
  engagementRateMOM: number;
  engagementRatePreviousYear: number;
  engagementRateYOY: number;
  actionRate: number;
  actionRatePreviousMonth: number;
  actionRateMOM: number;
  actionRatePreviousYear: number;
  actionRateYOY: number;
  impressions: number;
  impressionsPreviousMonth: number;
  impressionsMOM: number;
  impressionsPreviousYear: number;
  impressionsYOY: number;
  clicks: number;
  clicksPreviousMonth: number;
  clicksMOM: number;
  clicksPreviousYear: number;
  clicksYOY: number;
  clickThroughRate: number;
  clickThroughRatePreviousMonth: number;
  clickThroughRateMOM: number;
  clickThroughRatePreviousYear: number;
  clickThroughRateYOY: number;
  costPerClick: number;
  costPerClickPreviousMonth: number;
  costPerClickMOM: number;
  costPerClickPreviousYear: number;
  costPerClickYOY: number;
  costPerImpression: number;
  costPerImpressionPreviousMonth: number;
  costPerImpressionMOM: number;
  costPerImpressionPreviousYear: number;
  costPerImpressionYOY: number;
  totalVisits: number;
  totalVisitsPreviousMonth: number;
  totalVisitsMOM: number;
  totalVisitsPreviousYear: number;
  totalVisitsYOY: number;
  uniqueVisits: number;
  uniqueVisitsPreviousMonth: number;
  uniqueVisitsMOM: number;
  uniqueVisitsPreviousYear: number;
  uniqueVisitsYOY: number;
  formSubmissions: number;
  formSubmissionsPreviousMonth: number;
  formSubmissionsMOM: number;
  formSubmissionsPreviousYear: number;
  formSubmissionsYOY: number;
  phoneCalls: number;
  phoneCallsPreviousMonth: number;
  phoneCallsMOM: number;
  phoneCallsPreviousYear: number;
  phoneCallsYOY: number;
  conversionRate: number;
  conversionRatePreviousMonth: number;
  conversionRateMOM: number;
  conversionRatePreviousYear: number;
  conversionRateYOY: number;
  costPerAcquisition: number;
  costPerAcquisitionPreviousMonth: number;
  costPerAcquisitionMOM: number;
  costPerAcquisitionPreviousYear: number;
  costPerAcquisitionYOY: number;
  bounceRate: number;
  bounceRatePreviousMonth: number;
  bounceRateMOM: number;
  bounceRatePreviousYear: number;
  bounceRateYOY: number;
}


export interface IDigitalAdvertisingProviderScorecard {
  providerId: number;
  providerName: string;
  providerCode: string;
  metrics: IDigitalAdvertisingProviderScorecardMetric[];
}

export interface IDigitalAdvertisingProviderScorecardMetric {
  metricId: number;
  metricName: string;
  metricKey: string;
  seriesData: number[];
  metricValue: number;
  trend: number;
  trendChartLineColor: string;
  trendChartFillColor: string;
  metricMOM?: number;
  metricFormatter: () => {};
}

// inventory models
export interface InventoryOverviewBillboardResponseModel extends ReportResponseModel {
  results: InventoryOverviewBillboardReportRecord[];
}

export interface InventoryOverviewBillboardReportRecord extends ReportRecord {
  healthScore: number;
  healthScorePreviousMonth: number;
  inventory: number;
  inventoryPreviousMonth: number;
  demand: number;
  demandPreviousMonth: number;
  daysSupply: number;
  daysSupplyPreviousMonth: number;
}


export interface InventoryOverviewBillboardGraphMetricResponseModel extends ReportResponseModel {
  results: InventoryOverviewBillboardGraphMetricReportRecord[];
}

export interface InventoryOverviewBillboardGraphMetricReportRecord extends ReportRecord {
  date: Date;
  healthScore: number;
  inventory: number;
  demand: number;
  daysSupply: number;
}

export interface InventoryOverviewGraphMetricResponseModel extends ReportResponseModel {
  results: InventoryOverviewGraphMetricReportRecord[];
}

export interface InventoryOverviewGraphMetricReportRecord extends ReportRecord {
  date: Date;
  inventory: number;
  daysSupply: number;
  vdpViews: number;
  demand: number;
  ddrCreated: number;
  ddrSales: number;
  deactivations: number;
  saleForecast: number;
}

export interface InventoryOverviewSummaryMetricResponseModel extends ReportResponseModel {
  results: InventoryOverviewSummaryMetricReportRecord[];
}

export interface InventoryOverviewSummaryMetricReportRecord extends ReportRecord {
  entity: string;
  entityType: string;
  parentEntity: string;
  displayName: string;
  expandable: boolean;
  show: boolean;
  hasChildren: boolean;
  showChildren: boolean;
  photoScore: number;
  photoScorePreviousMonth: number;
  photoScorePreviousYear: number;
  photoScoreMOM: number;
  photoScoreYOY: number;
  commentScore: number;
  commentScorePreviousMonth: number;
  commentScorePreviousYear: number;
  commentScoreMOM: number;
  commentScoreYOY: number;
  inventory: number;
  inventoryPreviousMonth: number;
  inventoryPreviousYear: number;
  inventoryMOM: number;
  inventoryYOY: number;
  vdpViews: number;
  vdpViewsPreviousMonth: number;
  vdpViewsPreviousYear: number;
  vdpViewsMOM: number;
  vdpViewsYOY: number;
  demand: number;
  demandPreviousMonth: number;
  demandPreviousYear: number;
  demandMOM: number;
  demandYOY: number;
  averageMsrp: number;
  averageMsrpPreviousMonth: number;
  averageMsrpPreviousYear: number;
  averageMsrpMOM: number;
  averageMsrpYOY: number;
}

export interface InventoryOverviewClassSummaryMetricResponseModel extends ReportResponseModel {
  results: InventoryOverviewClassSummaryMetricReportRecord[];
}

export interface InventoryOverviewClassSummaryMetricReportRecord extends ReportRecord {
  vehicleClass: string;
  healthScore: number;
  commentScore: number;
  photoScore: number;
  inventory: number;
  vdpViews: number;
  demand: number;
  daySupply: number;
  percentOfSalesTarget: number;
}


export interface InventoryOverviewClassModelDetailMetricResponseModel extends ReportResponseModel {
  results: InventoryOverviewClassModelDetailMetricReportRecord[];
}

export interface InventoryOverviewClassModelDetailMetricReportRecord extends ReportResponseModel {
  modelCode: string;
  healthScore: number;
  photoScore: number;
  commentScore: number;
  inventory: number;
  previousInventory: number;
  vdpViews: number;
  previousVdpViews: number;
  demand: number;
  previousDemand: number;
  averageMsrp: number;
  previousAverageMsrp: number;
  percentOfSalesTarget: number;
}

export interface InventoryOverviewClassVehicleSummaryMetricResponseModel extends ReportResponseModel {
  results: InventoryOverviewClassVehicleSummaryMetricReportRecord[];
}

export interface InventoryOverviewClassVehicleSummaryMetricReportRecord extends ReportRecord {
  entity: string;
  entityType: string;
  parentEntity: string;
  displayName: string;
  expandable: boolean;
  show: boolean;
  hasChildren: boolean;
  showChildren: boolean;
  healthScore: number;
  healthScorePreviousMonth: number;
  healthScorePreviousYear: number;
  healthScoreMOM: number;
  healthScoreYOY: number;
  commentScore: number;
  commentScorePreviousMonth: number;
  commentScorePreviousYear: number;
  commentScoreMOM: number;
  commentScoreYOY: number;
  photoScore: number;
  photoScorePreviousMonth: number;
  photoScorePreviousYear: number;
  photoScoreMOM: number;
  photoScoreYOY: number;
  inventory: number;
  inventoryPreviousMonth: number;
  inventoryPreviousYear: number;
  inventoryMOM: number;
  inventoryYOY: number;
  vdpViews: number;
  vdpViewsPreviousMonth: number;
  vdpViewsPreviousYear: number;
  vdpViewsMOM: number;
  vdpViewsYOY: number;
  demand: number;
  demandPreviousMonth: number;
  demandPreviousYear: number;
  demandMOM: number;
  demandYOY: number;
  daysSypply: number;
  daysSypplyPreviousMonth: number;
  daysSypplyPreviousYear: number;
  daysSypplyMOM: number;
  daysSypplyYOY: number;
  averageMsrp: number;
  averageMsrpPreviousMonth: number;
  averageMsrpPreviousYear: number;
  averageMsrpMOM: number;
  averageMsrpYOY: number;
  percentOfSalesTarget: number;
  percentOfSalesTargetPreviousMonth: number;
  percentOfSalesTargetPreviousYear: number;
  percentOfSalesTargetMOM: number;
  percentOfSalesTargetYOY: number;
}

// start v2
export interface DealerLeadOverviewChartResponseModel extends ReportResponseModel {
  results: DealerLeadOverviewChartReportRecord[];
}

export interface DealerLeadOverviewChartReportRecord extends ReportRecord {
  month: Date;
  leadVolume: number;
  responded: number;
  closeRate: number;
}

export interface LeadOverviewBillboardResponseModel extends ReportResponseModel {
  results: LeadOverviewBillboardReportRecord[];
}

export interface LeadOverviewBillboardReportRecord extends ReportRecord {
  isCurrentMonth: boolean;
  leads: number;
  leadsPreviousMTD: number;
  leadsPreviousMonth: number;
  leadsMOM: number;
  leadsYOY: number;
  uniqueLeads: number;
  uniqueLeadsPreviousMTD: number;
  uniqueLeadsPreviousMonth: number;
  uniqueLeadsMOM: number;
  uniqueLeadsYOY: number;
  responseRate: number;
  responseRatePreviousMTD: number;
  responseRatePreviousMonth: number;
  responseRateMOM: number;
  responseRateYOY: number;
  responseRateLessThan60: number;
  responseRateLessThan60PreviousMTD: number;
  responseRateLessThan60PreviousMonth: number;
  responseRateLessThan60MOM: number;
  responseRateLessThan60YOY: number;
  appointmentRate: number;
  appointmentRateMTD: number;
  appointmentRatePreviousMonth: number;
  appointmentRateMonth: number;
  appointmentRateMOM: number;
  appointmentRateYOY: number;
  closeRate: number;
  closeRatePreviousMTD: number;
  closeRatePreviousMonth: number;
  closeRateMOM: number;
  closeRateYOY: number;
}


export interface LeadOverviewSourceTypeMetricResponseModel extends ReportResponseModel {
  results: LeadOverviewSourceTypeMetricReportRecord[];
}

export interface LeadOverviewSourceTypeMetricReportRecord extends ReportRecord {
  sourceType: string;
  uniqueLeads: number;
  uniqueLeadsMOM: number;
  uniqueLeadsYOY: number;
  bestMatchCloseRate: number;
  bestMatchloseRateMOM: number;
  bestMatchCloseRateYOY: number;
}

export interface LeadsOverviewBenchmarkResponseModel extends ReportResponseModel {
  results: LeadsOverviewBenchmarkReportRecord[];
}

export interface LeadsOverviewBenchmarkReportRecord extends ReportRecord {
  entity: string;
  entityType: string;
  parentEntity: string;
  displayName: string;
  expandable: boolean;
  show: boolean;
  hasChildren: boolean;
  showChildren: boolean;
  leadVolume: number;
  leadVolumeMOM: number;
  leadVolumePreviousMonth: number;
  leadVolumeYOY: number;
  leadVolumePreviousYear: number;
  uniqueLeads: number;
  uniqueLeadsMOM: number;
  uniqueLeadsPreviousMonth: number;
  uniqueLeadsYOY: number;
  uniqueLeadsPreviousYear: number;
  responseRateLessThan40: number;
  responseRateLessThan40PreviousMonth: number;
  responseRateLessThan40PreviousYear: number;
  responseRateLessThan40MOM: number;
  responseRateLessThan40YOY: number;
  responseRate: number;
  responseRatePreviousMonth: number;
  responseRatePreviousYear: number;
  responseRateMOM: number;
  responseRateYOY: number;
  averageResponseTimeLessThan48Hours: number;
  AverageResponseTimeLessThan48HoursPreviousMonth: number;
  AverageResponseTimeLessThan48HoursPreviousYear: number;
  AverageResponseTimeLessThan48HoursMOM: number;
  AverageResponseTimeLessThan48HoursYOY: number;
  closeRate: number;
  closeRatePreviousMonth: number;
  closeRatePreviousYear: number;
  closeRateMOM: number;
  closeRateYOY: number;
  closeRate60: number;
  closeRate60PreviousMonth: number;
  closeRate60PreviousYear: number;
  closeRate60MOM: number;
  closeRate60YOY: number;
  closeRate90: number;
  closeRate90PreviousMonth: number;
  closeRate90PreviousYear: number;
  closeRate90MOM: number;
  closeRate90YOY: number;
  leadSales: number;
  leadSalesPreviousMonth: number;
  leadSalesPreviousYear: number;
  leadSalesMOM: number;
  leadSalesYOY: number;
  appointments: number;
  appointmentsPreviousMonth: number;
  appointmentsPreviousYear: number;
  appointmentsMOM: number;
  appointmentsYOY: number;
  appointmentRate: number;
  appointmentRatePreviousMonth: number;
  appointmentRatePreviousYear: number;
  appointmentRateMOM: number;
  appointmentRateYOY: number;
}

export interface FacebookSummaryTableResponseModel extends ReportResponseModel {
  results: FacebookSummaryTableReportRecord[];
}

export interface FacebookSummaryTableReportRecord extends ReportRecord {
  className: string;
  campaignName: string;
  adSetName: string;
  adName: string;
  leadCount: number;
  saleCount: number;
  conversionRate: number;
}

export interface FacebookSummaryGraphReportRecord {
  date: Date;
  leadCount: number;
  saleCount: number;
  conversionRate: number;
}

export interface FacebookSummaryGraphResponseModel extends ReportResponseModel {
  results: FacebookSummaryGraphReportRecord[];
}

export interface LeadsOverviewSalesOverviewResponseModel extends ReportResponseModel {
  results: LeadsOverviewSalesOverviewReportRecord[];
}

export interface LeadsOverviewSalesOverviewReportRecord extends ReportRecord {

}

export interface LeadsOverviewMapResponseModel extends ReportResponseModel {
  results: LeadsOverviewMapReportRecord[];
}

export interface LeadsOverviewMapReportRecord extends ReportRecord {

}

export interface SalesContributionGraphMetricResponseModel extends ReportResponseModel {
  results: SalesContributionGraphMetricReportRecord[];
}

export interface SalesContributionGraphMetricReportRecord extends ReportRecord {
  date: Date;
  retailSales: number;
  totalDigitalSales: number;
  totalDigitalSalesContribution: number;
  brandLeadSales: number;
  brandLeadSalesContribution: number;
  thirdPartyLeadSales: number;
  thirdPartyLeadSalesContribution: number;
  dealerWebsiteLeadSales: number;
  dealerWebsiteLeadSalesContribution: number;
  eventLeadSales: number;
  eventLeadSalesContribution: number;
  brandPhoneSales: number;
  brandPhoneSalesContribution: number;
  dealerWebsitePhoneSales: number;
  dealerWebsitePhoneSalesContribution: number;
}

export interface SalesContributionTableMetricResponseModel extends ReportResponseModel {
  results: SalesContributionTableMetricReportRecord[];
}

export interface SalesContributionTableMetricReportRecord extends ReportRecord {
  entityType: string;
  entity: string;
  parentEntity: string;
  displayName: string;
  expandable: boolean;
  show: boolean;
  showChildren: boolean;
  hasChildren: boolean;
  retailSales: number;
  totalDigitalSales: number;
  totalDigitalSalesContribution: number;
  brandLeadSales: number;
  brandLeadSalesContribution: number;
  thirdPartyLeadSales: number;
  thirdPartyLeadSalesContribution: number;
  dealerWebsiteLeadSales: number;
  dealerWebsiteLeadSalesContribution: number;
  eventLeadSales: number;
  eventLeadSalesContribution: number;
  brandPhoneSales: number;
  brandPhoneSalesContribution: number;
  dealerWebsitePhoneSales: number;
  dealerWebsitePhoneSalesContribution: number;
}

export interface MultiLevelWebsiteGraphResponseModel extends ReportResponseModel {
  results: MultiLevelWebsiteGraphResponseModel[];
}
export interface MultiLevelWebsiteGraphResponseModel extends ReportRecord {
  date: Date;
  dimension: string;
  totalVisits: number;
  uniqueVisits: number;
  pageViews: number;
  pageViewsPerVisit: number;
  avgTimeOnSite: number;
  newInventoryDetailViews: number;
  usedInventoryDetailViews: number;
  cpoInventoryDetailViews: number;
  formSubmissions: number;
  formConversionRate: number;
  bounceRate: number;
  clickToCalls: number;
  actions: number;
  engagements: number;
  actionRate: number;
  engagementRate: number;
  newVdpViews: number;
  usedVdpViews: number;
  cpoVdpViews: number;
  otherVdpViews: number;
  totalVdpViews: number;
  newVdlViews: number;
  usedVlpViews: number;
  cpoVlpViews: number;
  otherVlpViews: number;
  mixedVlpViews: number;
  totalVlpViews: number;
}

export interface SalesOverviewBillboardResponseModel extends ReportResponseModel {
  results: SalesOverviewBillboardReportRecord[];
}

export interface SalesOverviewBillboardReportRecord extends ReportRecord {
  isCurrentMonth: boolean;
  totalSales: number;
  totalSalesMOM: number;
  totalSalesYOY: number;
  totalSalesPreviousMTD: number;
  totalSalesPreviousMonth: number;
  leadSales: number;
  leadSalesMOM: number;
  leadSalesYOY: number;
  leadSalesPreviousMTD: number;
  leadSalesPreviousMonth: number;
  leadContribution: number;
  leadContributionMOM: number;
  leadContributionYOY: number;
  leadContributionPreviousMTD: number;
  leadContributionPreviousMonth: number;
  averageTimeToSale: number;
  averageTimeToSaleMOM: number;
  averageTimeToSaleYOY: number;
  averageTimeToSalePreviousMTD: number;
  averageTimeToSalePreviousMonth: number;
  lostSales: number;
  lostSalesMOM: number;
  lostSalesYOY: number;
  lostSalesPreviousMTD: number;
  lostSalesPreviousMonth: number;
}

export interface SalesOverviewDailyVelocityResponseModel extends ReportResponseModel {
  results: SalesOverviewDailyVelocityReportRecord[];
}

export interface SalesOverviewDailyVelocityReportRecord extends ReportRecord {
  saleDate: number;
  newSales: number;
  usedSales: number;
}

export interface SalesOverviewMonthlyVelocityResponseModel extends ReportResponseModel {
  results: SalesOverviewMonthlyVelocityReportRecord[];
}

export interface SalesOverviewMonthlyVelocityReportRecord extends ReportRecord {
  salesMonth: Date;
  newSales: number;
  usedSales: number;
}

export interface SalesOverviewSummaryTableResponseModel extends ReportResponseModel {
  results: SalesOverviewSummaryTableReportRecord[];
}

export interface SalesOverviewSummaryTableReportRecord extends ReportRecord {
  entity: string;
  entityType: string;
  parentEntity: string;
  displayName: string;
  expandable: boolean;
  show: boolean;
  hasChildren: boolean;
  showChildren: boolean;
  totalSales: number;
  totalSalesPreviousMonth: number;
  totalSalesPreviousYear: number;
  totalSalesMOM: number;
  totalSalesYOY: number;
  leadSales: number;
  leadSalesPreviousMonth: number;
  leadSalesPreviousYear: number;
  leadSalesMOM: number;
  leadSalesYOY: number;
  leadContribution: number;
  leadContributionPreviousMonth: number;
  leadContributionPreviousYear: number;
  leadContributionMOM: number;
  leadContributionYOY: number;
  averageTimeToSale: number;
  averageTimeToSalePreviousMonth: number;
  averageTimeToSalePreviousYear: number;
  averageTimeToSaleMOM: number;
  averageTimeToSaleYOY: number;
  lostSales: number;
  lostSalesPreviousMonth: number;
  lostSalesPreviousYear: number;
  lostSalesMOM: number;
  lostSalesYOY: number;
}

export interface SalesOverviewSourceTypeResponseModel extends ReportResponseModel {
  results: SalesOverviewSourceTypeReportRecord[];
}

export interface SalesOverviewSourceTypeReportRecord extends ReportRecord {
  sourceType: string;
  salesContribution: number;
  leadContribution: number;
  salesContributionMOM: number;
  leadContributionMOM: number;
}

export interface ITrendCardV2Config {
  defaultPropertyKey: string,
  metricCharts: ITrendCardV2MetricCharts[]
}

export interface ITrendCardV2MetricCharts {
  propertyKey: string,
  chartOptions: Options
}

export interface ICardConfig {
  defaultPropertyKey?: string,
  metricCharts: IChannelCardMetricCharts[],
  seriesColors: string[]
}

export interface IChannelCardMetricCharts {
  propertyKey: string,
  chartOptions: Options
}

export interface IAnalyticalMetricCharts {
  chartOptions: Options
}

export interface WebsiteLandingPageGraphResponseModel extends ReportResponseModel {
  results: WebsiteLandingPageGraphMetricReportRecord[];
}

export interface WebsiteLandingPageGraphMetricReportRecord extends ReportRecord {
  date: Date;
  tiguanPageViews: number;
  atlasPageViews: number;
  jettaPageViews: number;
  warrantyPageViews: number;
  offersIncentivesPageViews: number;
  cpoPageViews: number;
  totalLandingPageViews: number;
}

export interface WebsiteLandingPageTableResponseModel extends ReportResponseModel {
  results: WebsiteLandingPageTableMetricReportRecord[];
}

export interface WebsiteLandingPageTableMetricReportRecord extends ReportRecord {
  entity: string;
  entityType: string;
  parentEntity: string;
  displayName: string;
  expandable: boolean;
  show: boolean;
  showChildren: boolean;
  hasChildren: boolean;
  tiguanPageViews: number;
  atlasPageViews: number;
  jettaPageViews: number;
  warrantyPageViews: number;
  offersIncentivesPageViews: number;
  cpoPageViews: number;
  totalLandingPageViews: number;
}

export interface WebsiteLegacyProviderScorecardResponseModel extends ReportResponseModel {
  results: WebsiteLegacyProviderScorecardMetricReportRecord[];
}

export interface WebsiteLegacyProviderScorecardMetricReportRecord extends ReportRecord {
  providerId: number;
  desktopScore: number;
  tabletScore: number;
  mobileScore: number;
  overallScore: number;
}

export interface WebsiteAfterSalesGraphResponseModel extends ReportResponseModel {
  results: WebsiteAfterSalesGraphMetricReportRecord[];
}

export interface WebsiteAfterSalesGraphMetricReportRecord extends ReportRecord {

}

export interface WebsiteAfterSalesTableResponseModel extends ReportResponseModel {
  results: WebsiteAfterSalesTableMetricReportRecord[];
}

export interface WebsiteAfterSalesTableMetricReportRecord extends ReportRecord {

}

export interface LeadTransactionTableMetricReportResponseModel extends ReportResponseModel {
  results: LeadTransactionTableMetricReportRecord[];
}

export interface LeadTransactionTableMetricReportRecord extends ReportRecord {
  leadId: number;
  leadKey: string;
  created: Date;
  leadTypeId: number;
  firstName: string;
  lastName: string;
  customerName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  homePhone: string;
  workPhone: string;
  mobilePhone: string;
  emailAddress: string;
  liveDate: Date;
  responded: Date;
  timeToRespond: number;
  dispositionType: string;
  vehicleYear: number;
  vehicleMake: string;
  vehicleModel: string;
  vehicleTrim: string;
  sourceName: string;
  sourceTypeId: number;
  dealerCode: string;
  dealerName: string;
  saleDealerCode: string;
  saleDealerName: string;
  saleZipCode: string;
  saleDate: Date;
  saleModel: string;
  customerComments: string;
  alternateDealerCount: string;
}

export interface LeadTransactionConciergeReportResponseModel extends ReportResponseModel {
  results: LeadTransactionConciergeReportRecord[];
}

export interface LeadTransactionConciergeReportRecord extends ReportRecord {
  leadId: number;
  filename: string;
  filepath: string;
  url: string;
}

export interface LeadTransactionDispositionReportResponseModel extends ReportResponseModel {
  results: LeadTransactionDispositionReportRecord[];
}

export interface LeadTransactionDispositionReportRecord extends ReportRecord {
  activityName: string;
  crmName: string;
  activityDate: Date;
  activityDetails: string;
}

export interface LevelTwoTrafficChannelBillboardGraphResponseModel extends ReportResponseModel {
  results: LevelTwoTrafficChannelBillboardGraphMetricRecord[];
}

export interface LevelTwoTrafficChannelBillboardGraphMetricRecord extends ReportRecord {
  date: Date;
  impressions: number;
  clicks: number;
  ctr: number;
  visits: number;
  uniqueVisitors: number;
  engagements: number;
  visitsWithEngagements: number;
  actions: number;
  visitsWithActions: number;
  actionRate: number;
  pageViews: number;
  newVdpViews: number;
  usedVdpViews: number;
  serviceViews: number;
  formSubmissions: number;
  clickToCalls: number;
  formConversionRate: number;
  totalConversionRate: number;
  engagementRate: number;
  bounceRate: number;
}

export interface LevelTwoTrafficChannelBillboardTableResponseModel extends ReportResponseModel {
  results: LevelTwoTrafficChannelBillboardTableMetricRecord[];
}

export interface LevelTwoTrafficChannelBillboardTableMetricRecord extends ReportRecord {
  dealerName: string;
  dealerCode: string;
  region: string;
  impressions: number;
  clicks: number;
  ctr: number;
  visits: number;
  uniqueVisitors: number;
  engagements: number;
  visitsWithEngagements: number;
  actions: number;
  visitsWithActions: number;
  pageViews: number;
  newVdpViews: number;
  usedVdpViews: number;
  serviceViews: number;
  formSubmissions: number;
  clickToCalls: number;
  formConversionRate: number;
  totalConversionRate: number;
  previousImpressions: number;
  previousClicks: number;
  previousCtr: number;
  previousVisits: number;
  previousUniqueVisitors: number;
  previousEngagements: number;
  previousVisitsWithEngagements: number;
  previousActions: number;
  previousVisitsWithActions: number;
  previousPageViews: number;
  previousNewVdpViews: number;
  previousUsedVdpViews: number;
  previousServiceViews: number;
  previousFormSubmissions: number;
  previousClickToCalls: number;
  previousFormConversionRate: number;
  previousTotalConversionRate: number;
}

export interface LevelTwoReferrerQualityGraphResponseModel extends ReportResponseModel {
  results: LevelTwoReferrerQualityGraphMetricRecord[];
}

export interface LevelTwoReferrerQualityGraphMetricRecord extends ReportRecord {
  date: Date;
  channelId: number;
  mediaTypelId: number;
  visits: number;
  pageViews: number;
  newVdpViews: number;
  usedVdpViews: number;
  serviceViews: number;
  engagements: number;
  visitsWithEngagements: number;
  engagementRate: number;
  formSubmissions: number;
  clickToCalls: number;
  formConversionRate: number;
  visitsWithActions: number;
  actionRate: number;
}

export interface LevelTwoReferrerQualityTableResponseModel extends ReportResponseModel {
  results: LevelTwoReferrerQualityTableMetricRecord[];
}

export interface LevelTwoReferrerQualityTableMetricRecord extends ReportRecord {
  referrer: string;
  channelId: number;
  visits: number;
  pageViews: number;
  newVdpViews: number;
  usedVdpViews: number;
  cpoVdpViews: number;
  serviceViews: number;
  engagements: number;
  visitsWithEngagements: number;
  engagementRate: number;
  formSubmissions: number;
  clickToCalls: number;
  formConversionRate: number;
  visitsWithActions: number;
  actionRate: number;
  previousVisits: number;
  previousPageViews: number;
  previousNewVdpViews: number;
  previousUsedVdpViews: number;
  previousCpoVdpViews: number;
  previousServiceViews: number;
  previousEngagements: number;
  previousVisitsWithEngagements: number;
  previousEngagementRate: number;
  previousFormSubmissions: number;
  previousClickToCalls: number;
  previousFormConversionRate: number;
  previousTotalConversionRate: number;
  previousVisitsWithActions: number;
  previousActionRate: number;
}

export interface LevelTwoDeviceTypeGraphResponseModel extends ReportResponseModel {
  results: LevelTwoDeviceTypeGraphMetricRecord[];
}

export interface LevelTwoDeviceTypeGraphMetricRecord extends ReportRecord {
  date: Date;
  deviceTypeId: number;
  visits: number;
  pageViews: number;
  newVdpViews: number;
  usedVdpViews: number;
  serviceViews: number;
  engagements: number;
  actions: number;
  bounces: number;
  bounceRate: number;
  formSubmissions: number;
  clickToCalls: number;
  formConversionRate: number;
  totalConversionRate: number;
}

export interface LevelTwoDeviceTypeTableResponseModel extends ReportResponseModel {
  results: LevelTwoDeviceTypeTableMetricRecord[];
}

export interface LevelTwoDeviceTypeTableMetricRecord extends ReportRecord {
  dealerName: string;
  dealerCode: string;
  region: string;
  desktopVisits: number;
  desktopEngagements: number;
  desktopActions: number;
  previousDesktopVisits: number;
  previousDesktopEngagements: number;
  previousDesktopActions: number;
  tabletVisits: number;
  tabletEngagements: number;
  tabletActions: number;
  previousTabletVisits: number;
  previousTabletEngagements: number;
  previousTabletActions: number;
  phoneVisits: number;
  phoneEngagements: number;
  phoneActions: number;
  previousPhoneVisits: number;
  previousPhoneEngagements: number;
  previousPhoneActions: number;
}

export interface LevelTwoTrafficTrendGraphResponseModel extends ReportResponseModel {
  results: LevelTwoTrafficTrendGraphMetricRecord[];
}

export interface LevelTwoTrafficTrendGraphMetricRecord extends ReportRecord {
  date: Date;
  visits: number;
  uniqueVisitors: number;
  vdpViews: number;
  formSubmissions: number;
  clickToCalls: number;
  serviceViews: number;
}

export interface LevelTwoTrafficTrendTableResponseModel extends ReportResponseModel {
  results: LevelTwoTrafficTrendTableMetricRecord[];
}

export interface LevelTwoTrafficTrendTableMetricRecord extends ReportRecord {
  dealerName: string;
  dealerCode: string;
  region: string;
  visits: number;
  uniqueVisitors: number;
  vdpViews: number;
  formSubmissions: number;
  clickToCalls: number;
  serviceViews: number;
  previousVisits: number;
  previousUniqueVisitors: number;
  previousVdpViews: number;
  previousFormSubmissions: number;
  previousClickToCalls: number;
  previousServiceViews: number;
}

export interface MetricTrendsReportResponseModel extends ReportResponseModel {
  results: MetricTrendsReportRecord[];
}

export interface MetricTrendsReportRecord extends ReportRecord {
  impressionsTrend: number;
  visitsTrend: number;
  uniqueVisitorsTrend: number;
  engagementsTrend: number;
  visitsWithEngagementsTrend: number;
  actionsTrend: number;
  visitsWithActionsTrend: number;
  pageViewsTrend: number;
}

export interface ReferrerQualitySummaryReportResponseModel extends ReportResponseModel {
  results: ReferrerQualitySummaryReportRecord[];
}

export interface ReferrerQualitySummaryReportRecord extends ReportRecord {
  referrer: string;
  visits: number;
  vdpViews: number;
  engagementRate: number;
  bounceRate: number;
  actionRate: number;
  salesSessions: number;
  serviceSessions: number;
  otherSessions: number;
  bounces: number;
  previousVisits: number;
  previousVdpViews: number;
  previousEngagementRate: number;
  previousBounceRate: number;
  visitsTrend: number;
  vdpViewsTrend: number;
  engagementRateTrend: number;
  bounceRateTrend: number;
  actionRateTrend: number;
}

export interface TrafficTrendGraphReportResponseModel extends ReportResponseModel {
  results: TrafficTrendGraphReportRecord[];
}

export interface TrafficTrendGraphReportRecord extends ReportRecord {
  date: Date;
  visits: number;
  uniqueVisitors: number;
  vdpNewViews: number;
  vdpUsedViews: number;
  vdpCpoViews: number;
  servicePageViews: number;
}

export interface LeadsBySourceTypeResponseModel extends ReportResponseModel {
  results: LeadsBySourceTypeReportRecord[];
}

export interface LeadsBySourceTypeReportRecord extends ReportRecord {
  date: Date;
  sourceTypeId: number;
  count: number;
  responded: number;
  respondedLessThanThreshold: number;
  responseTimeLessThanThreshold: number;
  respondedLessThan48Hours: number;
  responseTimeLessThan48Hours: number;
  totalResponseTime: number;
  hotLeads: number;
  appointments: number;
  ninetyDaySales: number;
  sixtyDaySales: number;
  thirtyDaySales: number;
}

export interface UniqueLeadsResponseModel extends ReportResponseModel {
  results: UniqueLeadsReportRecord[];
}

export interface UniqueLeadsReportRecord extends ReportRecord {
  date: Date;
  uniqueLeads: number;
}

export interface DealerSalesResponseModel extends ReportResponseModel {
  results: DealerSalesReportRecord[];
}

export interface DealerSalesReportRecord extends ReportRecord {
  date: Date;
  households: number;
  count: number;
  ninetyDaySales: number;
  sixtyDaySales: number;
  thirtyDaySales: number;
  lostSales: number;
}

export interface SalesActivityResponseModel extends ReportResponseModel {
  results: SalesActivityReportRecord[];
}

export interface SalesActivityReportRecord extends ReportRecord {
  date: Date;
  count: number;
  sourceTypeId: number;
  ninetyDaySales: number;
  sixtyDaySales: number;
  thirtyDaySales: number;
}

export interface SourcePerformanceResponseModel extends ReportResponseModel {
  results: SourcePerformanceReportRecord[];
}

export interface SourcePerformanceReportRecord extends ReportRecord {
  date: Date;
  source: string;
  sourceTypeId: number;
  count: number;
  cost: number;
}

export interface SalesBySourceResponseModel extends ReportResponseModel {
  results: SalesBySourceReportRecord[];
}

export interface SalesBySourceReportRecord extends ReportRecord {
  source: string;
  households: number;
  sales: number;
}

export interface SalesBySourceTypeResponseModel extends ReportResponseModel {
  results: SalesBySourceTypeReportRecord[];
}

export interface SalesBySourceTypeReportRecord extends ReportRecord {
  sourceTypeId: number;
  households: number;
  sales: number;
}

export interface DealerHierarchyMetricResponseModel extends ReportResponseModel {
  results: DealerHierarchyMetricReportRecord[];
}

export interface DealerHierarchyMetricReportRecord extends ReportRecord {
  hierarchy: string;
  hierarchyLevel: string;
  uniqueLeads: number;
}

export interface DealerPerformanceSummaryResponseModel extends ReportResponseModel {
  results: DealerPerformanceSummaryReportRecord[];
}

export interface DealerPerformanceSummaryReportRecord extends ReportRecord {
  orgCode2: string;
  orgCode1: string;
  dealerCode: string;
  dealer: string;
  leads: number;
  responded: number;
  respondedLessThanThreshold: number;
  totalResponseTime: number;
  sales: number;
  lostSales: number;
  gainedSales: number;
  respondedLessThan48Hours: number;
  responseTimeLessThan48Hours: number;
  totalVisits: number;
  uniqueVisits: number;
}

export interface DealerUniqueLeadsMetricResponseModel extends ReportResponseModel {
  results: DealerUniqueLeadsMetricReportRecord[];
}

export interface DealerUniqueLeadsMetricReportRecord extends ReportRecord {
  dealerCode: string;
  uniqueLeads: number;
}

export interface NationalDealerPerformanceSummaryResponseModel extends ReportResponseModel {
  results: NationalDealerPerformanceSummaryReportRecord[];
}

export interface NationalDealerPerformanceSummaryReportRecord extends ReportRecord {
  leads: number;
  responded: number;
  respondedLessThanThreshold: number;
  totalResponseTime: number;
  sales: number;
  lostSales: number;
  gainedSales: number;
  respondedLessThan48Hours: number;
  responseTimeLessThan48Hours: number;
}

export interface DigitalAdBenchmarkMetricResponseModel extends ReportResponseModel {
  results: DigitalAdBenchmarkMetricReportRecord[];
}

export interface DigitalAdBenchmarkMetricReportRecord extends ReportRecord {
  entity: string;
  impressions: number;
  clicks: number;
  phoneCalls: number;
  conversionRate: number;
  ctr: number;
  ptr: number;
  impressionsTrend: number;
  clicksTrend: number;
  phoneCallsTrend: number;
  conversionRateTrend: number;
  ctrTrend: number;
  ptrTrend: number;
}

export interface DigitalAdBillboardMetricResponseModel extends ReportResponseModel {
  results: DigitalAdBillboardMetricReportRecord[];
}

export interface DigitalAdBillboardMetricReportRecord extends ReportRecord {
  impressions: number;
  clicks: number;
  phoneCalls: number;
  conversions: number;
  previousImpressions: number;
  previousClicks: number;
  previousPhoneCalls: number;
  previousConversions: number;
}

export interface DigitalAdvertisingTrendSummaryResponseModel extends ReportResponseModel {
  results: DigitalAdvertisingTrendSummaryReportRecord[];
}

export interface DigitalAdvertisingTrendSummaryReportRecord extends ReportRecord {
  month: Date;
  deviceTypeId: number;
  impressions: number;
  clicks: number;
  phoneCalls: number;
  conversions: number;
}

export interface LevelTwoDealerPerformanceGraphResponseModel extends ReportResponseModel {
  results: LevelTwoDealerPerformanceGraphMetricRecord[];
}

export interface LevelTwoDealerPerformanceGraphMetricRecord extends ReportRecord {
  date: Date;
  dealerName: string;
  region: string;
  visits: number;
  pageViews: number;
  newVdpViews: number;
  usedVdpViews: number;
  serviceViews: number;
  visitsWithEngagements: number;
  bounces: number;
  formSubmissions: number;
  clickToCalls: number;
  visitsWithActions: number;
}

export interface LevelTwoDealerPerformanceTableResponseModel extends ReportResponseModel {
  results: LevelTwoDealerPerformanceTableMetricRecord[];
}

export interface LevelTwoDealerPerformanceTableMetricRecord extends ReportRecord {
  dealerName: string;
  dealerCode: string;
  region: string;
  visits: number;
  pageViews: number;
  newVdpViews: number;
  usedVdpViews: number;
  cpoVdpViews: number;
  serviceViews: number;
  visitsWithEngagements: number;
  bounces: number;
  formSubmissions: number;
  clickToCalls: number;
  visitsWithActions: number;
  previousVisits: number;
  previousPageViews: number;
  previousNewVdpViews: number;
  previousUsedVdpViews: number;
  previousCpoVdpViews: number;
  previousServiceViews: number;
  previousVisitsWithEngagements: number;
  previousBounces: number;
  previousFormSubmissions: number;
  previousClickToCalls: number;
  previousVisitsWithActions: number;
}

export interface LevelTwoCampaignPerformanceGraphResponseModel extends ReportResponseModel {
  results: LevelTwoCampaignPerformanceGraphMetricRecord[];
}

export interface LevelTwoCampaignPerformanceGraphMetricRecord extends ReportRecord {
  date: Date;
  spend: number;
  impressions: number;
  clicks: number;
  ctr: number;
  avgCpc: number;
  avgPosition: number;
}

export interface LevelTwoCampaignPerformanceTableResponseModel extends ReportResponseModel {
  results: LevelTwoCampaignPerformanceTableMetricRecord[];
}

export interface LevelTwoCampaignPerformanceTableMetricRecord extends ReportRecord {
  dealerName: string;
  dealerCode: string;
  region: string;
  spend: number;
  impressions: number;
  clicks: number;
  ctr: number;
  avgCpc: number;
  avgPosition: number;
  previousSpend: number;
  previousImpressions: number;
  previousClicks: number;
  previousCtr: number;
  previousAvgCpc: number;
  previousAvgPosition: number;
}

export interface SaleMakeModelReportResponseModel extends ReportResponseModel {
  results: SaleMakeModelReportRecord[];
}

export interface SaleMakeModelReportRecord extends ReportRecord {
  vehicleStatusId: number;
  vehicleMake: string;
  vehicleModel: string;
  vehicleSegment: string;
}

export interface ZipCodeSaleDataReportResponseModel extends ReportResponseModel {
  results: ZipCodeSaleDataReportRecord[];
}

export interface ZipCodeSaleDataReportRecord extends ReportRecord {
  zipCode: string;
  marketShare: number;
  latitude: number;
  longitude: number;
}

export interface CompetitiveSalesGraphReportResponseModel extends ReportResponseModel {
  results: CompetitiveSalesGraphReportRecord[];
}

export interface CompetitiveSalesGraphReportRecord extends ReportRecord {
  month: Date;
  rooftopSales: number;
  competitiveSales: number;
}

export interface CompetitiveSalesBrandModelTableReportResponseModel extends ReportResponseModel {
  results: CompetitiveSalesBrandModelTableReportRecord[];
}

export interface CompetitiveSalesBrandModelTableReportRecord extends ReportRecord {
  vehicleSegment: string;
  vehicleMake: string;
  vehicleModel: string;
  salesRank: number;
  rooftopSales: number;
  competitiveSales: number;
  rooftopBuySales: number;
  rooftopLeaseSales: number;
  competitiveBuySales: number;
  competitiveLeaseSales: number;
  segmentRank: number;
}

export interface CompetitiveSalesCompetitiveDealerTableReportResponseModel extends ReportResponseModel {
  results: CompetitiveSalesCompetitiveDealerTableReportRecord[];
}

export interface CompetitiveSalesCompetitiveDealerTableReportRecord extends ReportRecord {
  ihsDealerId: string;
  name: string;
  city: string;
  state: string;
  distanceToCenter: number;
  salesRank: number;
  dealerSales: number;
  buySales: number;
  leaseSales: number;
}

export interface CompetitiveSalesZipCodeTableReportResponseModel extends ReportResponseModel {
  results: CompetitiveSalesZipCodeTableReportRecord[];
}

export interface CompetitiveSalesZipCodeTableReportRecord extends ReportRecord {
  zipCode: string;
  city: string;
  state: string;
  distanceToCenter: number;
  rooftopSales: number;
  rooftopBuySales: number;
  rooftopLeaseSales: number;
  competitiveSales: number;
  competitiveBuySales: number;
  competitiveLeaseSales: number;
}

export interface CompetitiveSalesOverviewReportResponseModel extends ReportResponseModel {
  results: CompetitiveSalesOverviewReportRecord[];
}

export interface CompetitiveSalesOverviewReportRecord extends ReportRecord {
  month: Date;
  rooftopSales: number;
  previousRooftopSales: number;
  competitiveSales: number;
  previousCompetitiveSales: number;
}

export interface ICoordinate {
  lat: number;
  lng: number;
}

// User Activity Reports Models
export interface UserActivityOverviewTrendGraphResponseModel extends ReportResponseModel {
  results: UserActivityOverviewTrendGraphReportRecord[];
}

export interface UserActivityOverviewTrendGraphReportRecord extends ReportRecord {
  date: Date;
  sessions: number;
  pageViews: number;
  roleId: number;
}

export interface UserActivityOverviewTransactionalResponseModel extends ReportResponseModel {
  results: UserActivityOverviewTransactionalReportRecord[];
}

export interface UserActivityOverviewTransactionalReportRecord extends ReportRecord {
  timestamp: Date;
  pageName: string;
  reportSuiteName: string;
  role: string;
  roleEntity: string;
  name: string;
  username: string;
  dealerName: string;
}

export interface UserActivityOverviewUserSummaryResponseModel extends ReportResponseModel {
  results: UserActivityOverviewUserSummaryReportRecord[];
}

export interface UserActivityOverviewUserSummaryReportRecord extends ReportRecord {
  username: string;
  orgCode2: string;
  orgCode1: string;
  dealerName: string;
  dealerCode: string;
  sessions: number;
  pageViews: number;
}

export interface UserActivityOverviewBillboardTrendResponseModel extends ReportResponseModel {
  results: UserActivityOverviewBillboardTrendReportRecord[];
}

export interface UserActivityOverviewBillboardTrendReportRecord extends ReportRecord {
  date: Date;
  value: number;
}

export interface UserActivityOverviewDealerPerformanceResponseModel extends ReportResponseModel {
  results: UserActivityOverviewDealerPerformanceReportRecord[];
}

export interface UserActivityOverviewDealerPerformanceReportRecord extends ReportRecord {
  printDisplayName: string;
  dealerCode: string;

  sessions: number;
  sessionsPreviousMonth: number;
  sessionsPreviousYear: number;
  sessionsMOM: number;
  sessionsYOY: number;

  pageViews: number;
  pageViewsPreviousMonth: number;
  pageViewsPreviousYear: number;
  pageViewsMOM: number;
  pageViewsYOY: number;
}

export interface UserActivityOverviewBillboardResponseModel extends ReportResponseModel {
  results: UserActivityOverviewBillboardReportRecord[];
}

export interface UserActivityOverviewBillboardReportRecord extends ReportRecord {
  sessions: number;
  sessionsPreviousMonth: number;
  sessionsPreviousYear: number;
  sessionsMOM: number;
  sessionsYOY: number;
  pageViews: number;
  pageViewsPreviousMonth: number;
  pageViewsPreviousYear: number;
  pageViewsMOM: number;
  pageViewsYOY: number;
}

export interface IPreviousDateRangeDisplay {
  previousMonthDisplay?: string;
  previousMTDDisplay?: string;
  momDisplay?: string;
}

export interface BasePagedSortableRequest {
  pageIndex: number;
  pageSize: number;
  sortField?: string;
  ascending: boolean;
  searchTerm?: string;
}

export interface ImportRequest {
  key: string;
  names: string[];
}

export interface AppHttpError {
  originalError: HttpErrorResponse;
  userFriendlyMessage: string;
}